module.exports = __webpack_public_path__ + "assets/images/icons/icon_x-green.svg?v=2c4df094";